<template>
  <div
    class="work-card d-flex flex-column justify-content-center align-items-center"
  >
    <div class="work-card__icon">
      <img :src="item.icon" :alt="item.altText" />
    </div>
    <h4 class="work-card__title mb-2 mt-4">
      {{ item && item.step ? item.step : "" }}
    </h4>
    <p class="work-card__main-info mb-1">
      <template v-if="item && item.link">
        <a :href="item.link" class="contact-link">
          {{ item.description }}
        </a>
      </template>
      <template v-else>
        {{ item && item.description ? item.description : "" }}
      </template>
    </p>
    <p class="work-card__sub-info" v-if="item && item.subInfo">
      {{ item.subInfo }}
    </p>
  </div>
</template>

<script>
export default {
  name: "WorkCard",
  props: {
    item: Object,
  },
};
</script>

<style lang="scss" scoped>
.work-card {
  padding: 40px 25px 35px;
  margin-top: 0;
  min-height: 200px;
  border: 1px solid #e8e8e8;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
    transform: translateY(-2px);
  }

  &__icon {
    width: 70px;
    height: 70px;
    border-radius: 50%;
    padding: 15px;
    background: #0d47a1;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 0;

    img {
      width: 60%;
      height: auto;
      filter: brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(0%)
        hue-rotate(0deg) brightness(100%) contrast(100%);
    }
  }

  &__title {
    font-size: 18px;
    font-weight: 700;
    color: #2d3748;
    text-align: center;
    margin-bottom: 8px !important;
  }

  &__main-info {
    font-size: 16px;
    font-weight: 600;
    color: #2d3748;
    text-align: center;
    margin-bottom: 4px !important;

    .contact-link {
      color: #2d3748;
      text-decoration: none;

      &:hover {
        color: #0d47a1;
        text-decoration: none;
      }
    }
  }

  &__sub-info {
    font-size: 14px;
    font-weight: 400;
    color: #718096;
    text-align: center;
    margin-bottom: 0;
  }

  @media (max-width: 767.99px) {
    padding: 30px 20px 25px;
    min-height: 180px;

    &__icon {
      width: 60px;
      height: 60px;
    }

    &__title {
      font-size: 16px;
    }

    &__main-info {
      font-size: 15px;
    }
  }
}
</style>
